if (!customElements.get('currency-select')) {
  customElements.define(
    'currency-select',
    class CurrencySelect extends HTMLSelectElement {
      constructor () {
        super()

        this.handleChange = this.handleChange.bind(this)
      }

      connectedCallback () {
        this.addEventListener('change', this.handleChange)
      }

      disconnectedCallback () {
        this.removeEventListener('change', this.handleChange)
      }

      handleChange (e) {
        const redirectUrl = new URL(e.target.value, window.location.origin)
        const searchQuery = new URLSearchParams(window.location.search).get(
          'q',
        )

        if (searchQuery && !redirectUrl.searchParams.has('q')) {
          redirectUrl.searchParams.set('q', searchQuery)
        }

        redirectUrl.searchParams.set('redirect_origin', this.storefront)

        window.dataLayer = window.dataLayer || []

        window.dataLayer.push({
          event: 'cross_domain_redirect',
          event_context: 'currency-select',
          target_url: redirectUrl.href,
        })

        setTimeout(() => {
          window.location.href = redirectUrl.href
        }, 200)
      }

      get storefront () {
        if (window.location.hostname === 'eu.ohpolly.com') {
          return 'EU'
        }

        if (window.Shopify.shop === 'oh-polly-uk.myshopify.com') {
          return 'UK'
        }

        if (window.Shopify.shop === 'oh-polly-us.myshopify.com') {
          return 'US'
        }

        if (window.Shopify.shop === 'oh-polly-au.myshopify.com') {
          return 'AU'
        }

        if (window.Shopify.shop === 'oh-polly-de.myshopify.com') {
          return 'DE'
        }
      }
    },
    {
      extends: 'select',
    },
  )
}
